export const bestMatch = { fields: [], order: [] };
export const nameAsc = { fields: ['name'], order: ['asc'] };
export const nameDesc = { fields: ['name'], order: ['desc'] };
export const regionAsc = { fields: ['region'], order: ['asc'] };
export const regionDesc = { fields: ['region'], order: ['desc'] };
